import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"disabled":_vm.items.length === 0,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var onTooltip = ref.on;
return [_vm._t("default",null,{"onTooltip":onTooltip})]}}],null,true)},[_c('div',{staticStyle:{"max-width":"400px"}},[_c('TruncatedChipList',{attrs:{"items":_vm.items,"limit":_vm.limit,"small":true,"color":_vm.isDarkMode ? 'grey darken-1' : 'grey darken-4'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }